import styled from 'styled-components';
const DataAnalyleStyled = styled.div`
  .main_contain {
    margin-top: 24px;
    display: flex;
    .main_contain_left {
      width: 64%;
      .visited_day {
        width: 100%;
        height: 439px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 10px;
      }
      .register_day {
        width: 100%;
        height: 439px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-top: 4px;
        padding: 10px;
      }
    }
    .main_contain_right {
      width: 36%;
      margin-left: 4px;
      .register_shop_sort {
        width: 100%;
        height: 276px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 10px;
      }
      .buy_shop_sort {
        width: 100%;
        height: 276px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-top: 4px;
        padding: 10px;
      }
      .new_old_member_spread {
        width: 100%;
        height: 322px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-top: 4px;
        padding: 10px;
      }
    }
  }
  .new_member_register {
    width: 100%;
    height: 460px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin-top: 4px;
    display: flex;
    padding: 10px;
    .register_left {
      width: 455px;
      .bodyContent {
        position: relative;
        canvas {
          top: -30px !important;
        }
      }
    }
    .register_right {
      flex: 1;
      overflow-x: auto;
    }
  }
  .visited_member_sall {
    width: 100%;
    height: 460px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin-top: 4px;
    display: flex;
    padding: 10px;
    .sell_left {
      width: 455px;
      .bodyContent {
        position: relative;
        canvas {
          top: -30px !important;
        }
      }
    }
    .sell_right {
      flex: 1;
      overflow-x: auto;
    }
  }
  .coupon {
    display: flex;
    margin-top: 24px;
    height: 322px;
    .cancellate_rate {
      width: 64%;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding: 10px;
    }
    .cancellate_use_rate {
      width: 46%;
      margin-left: 4px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding: 10px;
    }
  }
  .clothing {
    display: flex;
    margin-top: 24px;
    height: 260px;
    .shoe_sort {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding: 10px;
    }
    .packet_sort {
      width: 46%;
      margin-left: 4px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding: 10px;
    }
  }
  .title_m {
    font-size: 18px;
    font-weight: 600;
  }
  td:nth-child(1),
  th:nth-child(1) {
    position: sticky;
    left: 0; /* 首行在左 */
    z-index: 1;
    background-color: #f5f5f5;
  }
  td:nth-child(2),
  th:nth-child(2) {
    position: ${(props) => (props.itemValue === 1 ? 'sticky' : 'static')};
    left: 200px; /* 首行在左 */
    z-index: 1;
    background-color: #f5f5f5;
  }
  td:nth-child(1) {
    background-color: #fff;
  }

  td:nth-child(2) {
    background-color: ${(props) =>
      props.itemValue === 1 ? '#fff' : 'inherit'};
  }
  thead {
    position: sticky;
    top: 0; /* 第一列最上 */
    z-index: 9;
    tr {
      height: 48px;
    }
  }
  th:nth-child(1) {
    z-index: 2;
  }
  th:nth-child(2) {
    z-index: ${(props) => (props.itemValue === 1 ? 2 : 1)};
  }
`;
export default DataAnalyleStyled;
